import React, { useState, useEffect } from 'react';
import { Box, HStack, Text, IconButton, VStack, createIcon, Icon, Spinner, Center, Link } from "@chakra-ui/react";
import { RiThumbDownLine, RiThumbUpLine } from "react-icons/ri";
import Feedback from './shared/Feedback';
import { ChevronRightIcon } from '@chakra-ui/icons';

import { DataStore } from '@aws-amplify/datastore';
import { Interactions } from '../../models';
import { Auth } from 'aws-amplify';

export const bus = createIcon({
    fillColor: { light: 'black', dark: 'white' },
    displayName: 'bus',
    viewBox: '0 0 30 30',
    // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
    path: (
      <>
       <path d="M18.3333 8.33326V4.70493C18.3281 3.79713 18.0288 2.91547 17.4805 2.19198C16.9322 1.46848 16.1642 0.942075 15.2917 0.691592C11.824 -0.229229 8.17602 -0.229229 4.70833 0.691592C3.83577 0.942075 3.06782 1.46848 2.51948 2.19198C1.97115 2.91547 1.67195 3.79713 1.66667 4.70493V8.33326C1.22464 8.33326 0.800716 8.50885 0.488155 8.82142C0.175595 9.13398 0 9.5579 0 9.99993L0 10.8333C0 11.2753 0.175595 11.6992 0.488155 12.0118C0.800716 12.3243 1.22464 12.4999 1.66667 12.4999V14.1666C1.66628 14.8135 1.81671 15.4516 2.10602 16.0302C2.39534 16.6089 2.81556 17.1121 3.33333 17.4999V17.9166C3.33281 18.4332 3.52428 18.9316 3.87057 19.3151C4.21686 19.6985 4.69326 19.9396 5.20729 19.9915C5.72132 20.0434 6.23631 19.9025 6.65228 19.596C7.06825 19.2896 7.35552 18.8396 7.45833 18.3333H12.5417C12.6445 18.8396 12.9318 19.2896 13.3477 19.596C13.7637 19.9025 14.2787 20.0434 14.7927 19.9915C15.3067 19.9396 15.7831 19.6985 16.1294 19.3151C16.4757 18.9316 16.6672 18.4332 16.6667 17.9166V17.4999C17.1844 17.1121 17.6047 16.6089 17.894 16.0302C18.1833 15.4516 18.3337 14.8135 18.3333 14.1666V12.4999C18.7754 12.4999 19.1993 12.3243 19.5118 12.0118C19.8244 11.6992 20 11.2753 20 10.8333V9.99993C20 9.5579 19.8244 9.13398 19.5118 8.82142C19.1993 8.50885 18.7754 8.33326 18.3333 8.33326ZM10.8333 10.8333V5.83326H16.6667V10.8333H10.8333ZM3.33333 10.8333V5.83326H9.16667V10.8333H3.33333ZM5.16667 2.29326C8.33476 1.45797 11.6652 1.45797 14.8333 2.29326C15.2717 2.41442 15.6688 2.6529 15.9817 2.98301C16.2946 3.31311 16.5116 3.72233 16.6092 4.16659H3.39083C3.48841 3.72233 3.70535 3.31311 4.01827 2.98301C4.3312 2.6529 4.72825 2.41442 5.16667 2.29326ZM14.1667 16.6666H5.83333C5.17029 16.6666 4.53441 16.4032 4.06557 15.9344C3.59673 15.4655 3.33333 14.8296 3.33333 14.1666V12.4999H5V13.3333C5 13.5543 5.0878 13.7662 5.24408 13.9225C5.40036 14.0788 5.61232 14.1666 5.83333 14.1666C6.05435 14.1666 6.26631 14.0788 6.42259 13.9225C6.57887 13.7662 6.66667 13.5543 6.66667 13.3333V12.4999H13.3333V13.3333C13.3333 13.5543 13.4211 13.7662 13.5774 13.9225C13.7337 14.0788 13.9457 14.1666 14.1667 14.1666C14.3877 14.1666 14.5996 14.0788 14.7559 13.9225C14.9122 13.7662 15 13.5543 15 13.3333V12.4999H16.6667V14.1666C16.6667 14.8296 16.4033 15.4655 15.9344 15.9344C15.4656 16.4032 14.8297 16.6666 14.1667 16.6666Z"
       fill="currentColor" />
      </>
    ),
  })


function NearestBusStop(sessionContext) {

    const [count, setCount] = useState(0);
    const [clickCounter, setClickCounter] = useState(0);
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [intersectionObserver, setIntersectionObserver] = useState(null);
    const [busStop, setBusStop] = useState([]);
    const [loading, setLoading] = useState(true);

    var apiUrl = 'https://jedha.lancaster.ac.uk/transport/api/v1/BusStops?longitude=' + sessionContext.sessionContext.position.longitude + '&latitude=' + sessionContext.sessionContext.position.latitude + '&token=a669a058-4284-4eb0-9f14-36e717ed04d8';

    useEffect(() => {
        if (sessionContext.sessionContext.position.longitude === undefined && sessionContext.sessionContext.position.latitude === undefined) {
            return;
        }
        fetch(apiUrl)
            .then(res => res.json())
            .then(data => {
                setBusStop(data);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
            });
    }, [sessionContext.sessionContext.position.longitude, sessionContext.sessionContext.position.latitude]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsTimerRunning(true);
                } else {
                    setIsTimerRunning(false);
                }
            },
            {
                root: null,
                rootMargin: "0px",
                threshold: [0, 1]
            }
        );

        setIntersectionObserver(observer);

        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        if (!intersectionObserver) {
            return;
        }

        const widgetEl = document.getElementById(NearestBusStop.name);
        intersectionObserver.observe(widgetEl);

        return () => {
            intersectionObserver.unobserve(widgetEl);
        };
    }, [intersectionObserver]);

    useEffect(() => {
        let timerId = null;

        if (isTimerRunning) {
            timerId = setInterval(() => {
                setCount(count + 1);
            }, 1000);
        }

        return () => {
            clearInterval(timerId);
        };
    }, [isTimerRunning, count]);


    function degrees_to_radians(degrees) {
        var pi = Math.PI;
        return degrees * (pi/180);
    }

    const calculateDistance = (lat1, lon1, lat2, lon2) => {
        var R = 6371; // Radius of the earth in km
        var dLat = degrees_to_radians(lat2-lat1);  // deg2rad below
        var dLon = degrees_to_radians(lon2-lon1); 
        var a = 
            Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(degrees_to_radians(lat1)) * Math.cos(degrees_to_radians(lat2)) * 
            Math.sin(dLon/2) * Math.sin(dLon/2)
            ; 
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
        var d = R * c; // Distance in km
        return d;
    }

    const [userID, setUserID] = useState("");
    const [userRole, setUserRole] = useState("");

      useEffect(() => {
          const getUserID = async () => {
              const user = await Auth.currentAuthenticatedUser();
              setUserID(user.attributes.sub);
              setUserRole(user.attributes['custom:role']);
          };
          getUserID();
      }, []);
  
      const getTime = () => {
        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        var dateTime = date+' '+time;
        return dateTime;
    }

    

    async function logInteraction () {
        await DataStore.save(
            new Interactions({
                "userSub": userID,
                "long": sessionContext.sessionContext.position.longitude,
                "lat": sessionContext.sessionContext.position.latitude,
                "time": getTime(),
                "feedbackType": "USEFUL_WIDGET",
                "interactionType": "CLICKED",
                "userID": userID,
                "duration": count,
                "clicks": clickCounter,
                "widgetName": "Nearest Bus Widget",
                "UserRole": userRole.toUpperCase()
            })
        );
    }



    return (
        <>
            <Box
                id={NearestBusStop.name}
                w="100%"
                h="410px"
                bg={`linear-gradient(to bottom, ${'#214456'}, ${'#214456'})`}
                borderRadius="15px"
                px={4}
                py={3}
                onClick={() => setClickCounter(clickCounter + 1)}
            >
                <HStack my={1} alignItems="center" justifyContent="space-between">
                    <Text fontSize="md" fontWeight="bold" color={"whiteAlpha.700"}>
                        Nearest Bus Stop
                    </Text>
                    <Feedback widgetName="Nearest Bus Widget" sessionContext={sessionContext} clicks={clickCounter} />
                </HStack>

                {loading === false ? (
                <>
                    {busStop.slice(0,5).map((stop, index) => (
                        <div key={index}>
                            <Box
                                w="100%"
                                h="70px"
                            >
                                <HStack
                                    w="100%"
                                    h="100%"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Box
                                        w="46px"
                                        h="46px"
                                        bg="whiteAlpha.900"
                                        borderRadius="10px"
                                        display="flex"
                                        p={3}
                                        mr={3}
                                    >
                                        <Icon
                                            as={bus}
                                            color={"#214456"}
                                            w={8}
                                            h={8}
                                        />
                                                    
                                    </Box>
                                    <VStack alignItems="flex-start" justifyContent="center" w="100%">
                                        <Text fontSize="md" fontWeight="bold" mt={"0px"} color={"whiteAlpha.700"}>
                                        {stop.commonName}
                                        </Text>
                                        <Text fontSize="sm" fontWeight="normal" mt={"0px"} color={"whiteAlpha.700"}>
                                            {calculateDistance(stop.latitude, stop.longitude, sessionContext.sessionContext.position.latitude, sessionContext.sessionContext.position.longitude).toFixed(2)} km away
                                        </Text>
                                    </VStack>
                                    <Link href={'https://www.google.com/maps/dir/?api=1&destination=' + stop.latitude + ',' + stop.longitude} isExternal>
                                        <IconButton borderColor={"white"} color="white" size="sm" variant="outline" icon={<Icon as={ChevronRightIcon} />} onClick={() => logInteraction()} isDisabled={sessionContext.sessionContext.position.latitude === undefined} />
                                    </Link>
                                </HStack>
                            </Box>
                        </div>
                    ))}
                </>
                ) : (
                    <>
                        <Center w="100%" h="100%" alignContent={"center"} justifyContent={"center"}>
                            <Spinner color="white" />
                            <Text fontSize="md" fontWeight="bold" color={"whiteAlpha.700"} ml={2}>
                                Loading...
                            </Text>
                        </Center>
                    </>
                )}
            </Box>
        </>
    );
}

export default NearestBusStop;



